module.exports = __webpack_public_path__ + "28b67065/img/scraper-icon.df6ccde5.svg";